import React from 'react';
import Page from '../../components/page';

export default function (props) {
	return (
		<Page title='Om oss'>
			<a className='btn btn-primary m-1' href='#/home'>
				Vår hemsida
			</a>
			<hr />
		</Page>
	);
}
